import { ButtonType, ButtonWidget, DialogPositioningBehavior, DialogProps, DialogType, DialogWidget, HorizontalOriginOption, VerticalOriginOption } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../gen-src/Localize';
import { CommonStyles } from '../../commonInfra/styles/CommonStyles';

import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { QuerySuggestionViewModel } from '../viewModels/QuerySuggestionViewModel';
import { activeSectionItem, focusBorder, maginifierIcon, pastQueryItemIcon, querySuggestionItem, querySuggestionItemIcon, querySuggestionSection, section, sectionHeader, sectionHeaderTitle, sectionItem, sectionItemAutoFitContent, sectionItemFixedContent, sectionItemHorizontalLayout, useColorForHighlight } from './OmniboxV2Styles';

export const QuerySuggestionTestId = 'QuerySuggestion';

export function QuerySuggestion(props: { viewModel: QuerySuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    const clearButtonElementRef = React.useRef<any>(null);

    const dialogWidgetContent: JSX.Element = <>
        <div>{Messages.omniboxClearPastQueryConfirmationDialogMessage()}</div>
        <div style={{ marginTop: 12, textAlign: 'right', whiteSpace: 'nowrap' }}>
            <ButtonWidget buttonType={ButtonType.Outline} onClick={() => { viewModel.onClearConformationDialogDismissed() }}>Cancel</ButtonWidget>
            <ButtonWidget style={{ marginLeft: 12 }} buttonType={ButtonType.Destructive} onClick={() => { viewModel.removeAllpastQueryItem() }}>{Messages.omniboxClearPastQueryConfirmationDialogActionName()}</ButtonWidget>
        </div>
    </>;

    const clearConfirmationDialogWidgetProps: DialogProps = {
        title: Messages.omniboxClearPastQueryConfirmationDialogTitle(),
        dialogBodyStyle: { paddingTop: 12, paddingBottom: 12 },
        dialogWidth: 375,
        type: DialogType.NormalWithTitleBar,
        isModal: true,
        isGlassTransparent: false,
        shouldReturnFocusOnClose: false,
        handleGlassClick: () => { viewModel.onClearConformationDialogDismissed() },
        onCloseRequest: () => { viewModel.onClearConformationDialogDismissed() },
        testId: 'omnibox-ClearConformationDialog',
        showCloseButton: false,
        showFooter: false,
        disableAutoFocus: false,
        positioningBehavior: DialogPositioningBehavior.Centered,
        getAnchorClientRect: () => getClearButtonAnchor(),
        anchorOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.bottom },
        children: dialogWidgetContent,
    };

    return (viewModel.querySuggestionItems && viewModel.querySuggestionItems.length > 0) ? <div data-tb-test-id={QuerySuggestionTestId} className={[section, querySuggestionSection, (viewModel.omniboxViewModel.shouldUseColorHighlight() ? useColorForHighlight : null)].join(' ')}>
        {viewModel.shouldShowHeader ? <div className={sectionHeader}>
            <div className={[sectionItemAutoFitContent, sectionHeaderTitle].join(' ')}>{Messages.omniboxClearPastQueryHeader()}</div>
            <div className={sectionItemFixedContent} style={{ paddingRight: 2 }}>
                <a id={viewModel.clearButtonNavigationItem.getIdentifier()} href='#' role='option' ref={clearButtonElementRef} aria-selected={viewModel.clearButtonNavigationItem === viewModel.currentKeyboardNavigableItem}
                    className={viewModel.clearButtonNavigationItem === viewModel.currentKeyboardNavigableItem ? focusBorder : null} onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onClearClicked(); }}>
                    {Messages.omniboxClearPastQueryClear()}
                </a>
            </div>
            {viewModel.clearConfirmationDialogIsOpen ? <DialogWidget {...clearConfirmationDialogWidgetProps}></DialogWidget> : null}
        </div> : null}
        {
            viewModel.querySuggestionItems.map((item, index) => <a id={item.getIdentifier()} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem} key={index} href={item.url} className={[sectionItem, sectionItemHorizontalLayout, querySuggestionItem, (item === viewModel.currentKeyboardNavigableItem ? activeSectionItem : '')].join(' ')} onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.hitPastQueryItem(item, index); }}>
                <div className={[sectionItemFixedContent, querySuggestionItemIcon, item.isPastQuery ? pastQueryItemIcon : maginifierIcon].join(' ')}></div>
                <div className={sectionItemAutoFitContent} style={CommonStyles.Layout.TextEllipsis}>
                    {item.segments.map((segment, index) => <span key={index}>{segment.keywordToAppend ? <strong>{segment.text}</strong> : <>{segment.text}</>}</span>)}
                </div>
            </a>)
        }
    </div > : null;

    function getClearButtonAnchor(): ClientRect {
        if (clearButtonElementRef?.current) {
            return clearButtonElementRef.current.getBoundingClientRect();
        }

        return {} as ClientRect;
    }
}